interface EmptyStateProps {
  icon: string;
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void };
  compact?: boolean;
}

export function EmptyState({ icon, title, subtitle, action, compact }: EmptyStateProps) {
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: compact ? "auto" : "100%",
      minHeight: compact ? 120 : 280,
      padding: compact ? "1.5rem" : "3rem 2rem",
      textAlign: "center",
      gap: compact ? "0.6rem" : "0.8rem",
    }}>
      <div style={{
        width: compact ? 40 : 56,
        height: compact ? 40 : 56,
        borderRadius: "14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--ot-accent-dim, rgba(79,143,255,0.08))",
        border: "1px solid var(--ot-border, rgba(255,255,255,0.06))",
        marginBottom: compact ? "0.2rem" : "0.4rem",
      }}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--ot-accent, #4f8fff)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            width: compact ? 20 : 28,
            height: compact ? 20 : 28,
            opacity: 0.7,
          }}
        >
          <path d={icon} />
        </svg>
      </div>

      <div style={{
        fontSize: compact ? "0.82rem" : "0.95rem",
        fontWeight: 600,
        color: "var(--ot-text-primary, #e6edf3)",
        fontFamily: "var(--ot-font-mono, 'JetBrains Mono', monospace)",
        letterSpacing: "-0.01em",
      }}>
        {title}
      </div>

      {subtitle && (
        <div style={{
          fontSize: compact ? "0.7rem" : "0.78rem",
          color: "var(--ot-text-secondary, #8b949e)",
          maxWidth: 380,
          lineHeight: 1.55,
          fontFamily: "var(--ot-font-mono, 'JetBrains Mono', monospace)",
        }}>
          {subtitle}
        </div>
      )}

      {action && (
        <button
          onClick={action.onClick}
          style={{
            marginTop: compact ? "0.4rem" : "0.6rem",
            padding: "0.4rem 1rem",
            borderRadius: "6px",
            border: "1px solid var(--ot-accent, #4f8fff)",
            background: "var(--ot-accent-dim, rgba(79,143,255,0.08))",
            color: "var(--ot-accent, #4f8fff)",
            fontSize: "0.75rem",
            fontWeight: 500,
            fontFamily: "var(--ot-font-mono, 'JetBrains Mono', monospace)",
            cursor: "pointer",
            transition: "all 0.15s ease",
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
